import type { FriendContact } from '../network/SocialService';

export interface SocialNotificationSummary {
  total: number;
  directMessages: number;
  friendRequests: number;
  aria: string;
}

interface NotificationOverview {
  friends: readonly Pick<FriendContact, 'unreadCount'>[];
  incoming: readonly unknown[];
}

export function socialNotificationSummary(overview: NotificationOverview): SocialNotificationSummary {
  const directMessages = overview.friends.reduce((sum, friend) => (
    sum + Math.max(0, Math.floor(friend.unreadCount))
  ), 0);
  const friendRequests = overview.incoming.length;
  const total = directMessages + friendRequests;
  const notices: string[] = [];
  if (friendRequests > 0) notices.push(`${friendRequests} new friend ${friendRequests === 1 ? 'request' : 'requests'}`);
  if (directMessages > 0) notices.push(`${directMessages} unread ${directMessages === 1 ? 'signal' : 'signals'}`);
  return {
    total,
    directMessages,
    friendRequests,
    aria: notices.length > 0 ? `Friends, ${notices.join(', ')}` : 'Friends',
  };
}
